<template>
	<div>
		<section class="bg-white xl:px-28 flex flex-col items-center">
			<div
				class="lg:pt-28 flex flex-col-reverse justify-center lg:flex-row lg:justify-between lg:items-center max-w-screen-xl px-4 lg:px-0 py-8 mx-auto lg:gap-8 xl:gap-0 lg:py-16">
				<div class="mr-auto text-center lg:text-left lg:mr-8">
					<h1
						class="gradText w-full mb-4 text-4xl font-extrabold tracking-tight leading-none md:text-5xl xl:text-6xl dark:text-white">
						Sole platform
						<br />
						to pass it all
					</h1>
					<p
						class="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
						From project idea dillema to search of drawing instruments, get all
						help at one place. Join Pass2Peer and start your contribution now!<br />
						Because, <span class="font-semibold italic text-purple-500">"Sharing is Caring"</span>
					</p>
					<router-link
						v-if="store.loggedIn"
						to="/services"
						class="inline-flex items-center justify-center px-5 py-3 mr-3 text-base font-medium text-center text-purple-700 rounded-lg border border-purple-700 bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 dark:focus:ring-primary-900">
						Get started
						<svg
							class="w-5 h-5 ml-2 -mr-1"
							fill="currentColor"
							viewBox="0 0 20 20"
							xmlns="http://www.w3.org/2000/svg">
							<path
								fill-rule="evenodd"
								d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
								clip-rule="evenodd"></path>
						</svg>
					</router-link>
					<router-link
						v-else
						to="/signup"
						class="inline-flex items-center justify-center px-5 py-3 text-base font-medium text-center text-white bg-purple-500 rounded-lg dark:text-white dark:border-gray-700 dark:hover:bg-gray-700 dark:focus:ring-gray-800">
						Signup now
					</router-link>
				</div>
				<div class="flex justify-center mb-20 lg:mb-0 lg:ml-2">
					<img
						src="@/assets/hero.gif"
						alt="mockup" />
				</div>
			</div>
			<svg
				class="w-12 h-16 mt-6"
				xmlns="http://www.w3.org/2000/svg"
				shape-rendering="geometricPrecision"
				text-rendering="geometricPrecision"
				image-rendering="optimizeQuality"
				fill-rule="evenodd"
				clip-rule="evenodd"
				viewBox="0 0 267 512.46">
				<path
					fill-rule="nonzero"
					d="M133.5 0c36.67 0 70.05 15.03 94.25 39.21l.06.07C251.99 63.47 267 96.84 267 133.5v151.22c0 36.67-15.03 70.04-39.21 94.24l-.06.06c-24.2 24.18-57.57 39.19-94.23 39.19-36.67 0-70.05-15.02-94.25-39.21l-.06-.06C15.01 354.74 0 321.37 0 284.72V133.5c0-36.67 15.03-70.04 39.21-94.25l.06-.06C63.47 15.02 96.84 0 133.5 0zM98.79 447.32l34.7 34.72 34.77-34.72 15.16 15.24-49.98 49.9-49.89-49.9 15.24-15.24zm34.71-130.89c12.5 0 22.74-10.23 22.74-22.73v-30.34c0-12.51-10.24-22.74-22.74-22.74-12.5 0-22.73 10.23-22.73 22.74v30.34c0 12.5 10.23 22.73 22.73 22.73zm0-294.87c-30.81 0-58.8 12.59-79.05 32.85-20.31 20.3-32.89 48.29-32.89 79.09v151.22c0 30.8 12.58 58.79 32.85 79.05 20.29 20.3 48.28 32.88 79.09 32.88 30.81 0 58.8-12.58 79.05-32.85 20.3-20.29 32.89-48.28 32.89-79.08V133.5c0-30.8-12.59-58.79-32.85-79.05-20.29-20.3-48.28-32.89-79.09-32.89z" />
			</svg>
		</section>

		<section class="text-gray-600 body-font">
			<div class="container px-5 py-24 mx-auto">
				<div class="text-center mb-20">
					<h1
						class="sm:text-3xl text-2xl font-medium title-font text-gray-900 mb-4">
						At Paas2Peer, We Provide Awesome Services
					</h1>
					<p
						class="text-base leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto text-gray-500s">
						We provide services that helps decreasing student's worries and we
						thrive to provide solutions to the problems that are at heart of
						every student
					</p>
					<div class="flex mt-6 justify-center">
						<div class="w-24 h-1 rounded-full bg-purple-700 inline-flex"></div>
					</div>
				</div>
				<div class="flex flex-wrap -m-4">
					<div class="p-4 lg:w-1/3">
						<div
							class="h-full bg-gray-100 bg-opacity-75 px-8 py-16 rounded-lg overflow-hidden text-center relative">
							<h2
								class="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">
								SERVICE
							</h2>
							<h1
								class="title-font sm:text-2xl text-xl font-medium text-gray-900 mb-3 py-2">
								Engineering Drawing Instruments
							</h1>
							<p class="leading-relaxed mb-3">
								An all-student platform to lend, sell or share drawing
								instruments that are required for Engineering Graphics
							</p>
							<router-link
								to="/instruments"
								class="text-purple-700 inline-flex items-center">
								Learn More
								<svg
									class="w-4 h-4 ml-2"
									viewBox="0 0 24 24"
									stroke="currentColor"
									stroke-width="2"
									fill="none"
									stroke-linecap="round"
									stroke-linejoin="round">
									<path d="M5 12h14"></path>
									<path d="M12 5l7 7-7 7"></path>
								</svg>
							</router-link>
						</div>
					</div>
					<div class="p-4 lg:w-1/3">
						<div
							class="h-full bg-gray-100 bg-opacity-75 px-8 py-16 rounded-lg overflow-hidden text-center relative">
							<h2
								class="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">
								SERVICE
							</h2>
							<h1
								class="title-font sm:text-2xl text-xl font-medium text-gray-900 mb-3 py-2">
								Mini/Major Project
								<br />
								Black Book
							</h1>
							<p class="leading-relaxed mb-3">
								The search for inspiration for projects ends here, providing
								blackbooks of previously performed projects on a single platform
							</p>
							<router-link to="/blackbooks" class="text-purple-700 inline-flex items-center">
								Learn More
								<svg
									class="w-4 h-4 ml-2"
									viewBox="0 0 24 24"
									stroke="currentColor"
									stroke-width="2"
									fill="none"
									stroke-linecap="round"
									stroke-linejoin="round">
									<path d="M5 12h14"></path>
									<path d="M12 5l7 7-7 7"></path>
								</svg>
							</router-link>
						</div>
					</div>
					<div class="p-4 lg:w-1/3">
						<div
							class="h-full bg-gray-100 bg-opacity-75 px-8 py-16 rounded-lg overflow-hidden text-center relative">
							<h2
								class="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">
								SERVICE
							</h2>
							<h1
								class="title-font sm:text-2xl text-xl font-medium text-gray-900 mb-3 py-2">
								Previous Year
								<br />
								Question Papers
							</h1>
							<p class="leading-relaxed mb-3">
								Here comes the quickest stop before exams to look for the
								previous year's question papers all together and easy to access
								from
							</p>
							<router-link to="/pyqpapers" class="text-purple-700 inline-flex items-center">
								Learn More
								<svg
									class="w-4 h-4 ml-2"
									viewBox="0 0 24 24"
									stroke="currentColor"
									stroke-width="2"
									fill="none"
									stroke-linecap="round"
									stroke-linejoin="round">
									<path d="M5 12h14"></path>
									<path d="M12 5l7 7-7 7"></path>
								</svg>
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section class="bg-white dark:bg-gray-900">
			<div
				class="items-center text-center lg:text-left max-w-screen-xl px-4 py-8 mx-auto lg:grid lg:grid-cols-4 lg:gap-16 xl:gap-24 lg:py-24 lg:px-6">
				<div class="col-span-2 mb-8">
					<p class="text-lg font-medium text-purple-700 dark:text-purple-700">
						Trusted Worldwide
					</p>
					<h2
						class="mt-3 mb-4 text-3xl font-extrabold tracking-tight text-gray-900 md:text-3xl dark:text-white">
						Trusted by over 10+ thousand students and 500+ communities
					</h2>
					<p class="font-light text-gray-500 sm:text-xl dark:text-gray-400">
						Our ease in share standards are at the heart of all we do.
						<br />
						We work tirelessly to provide seamless material sharing online.
					</p>
				</div>
				<div
					class="col-span-2 space-y-8 md:grid md:grid-cols-2 md:gap-12 md:space-y-0">
					<div class="w-full flex flex-col items-center lg:items-start">
						<svg
							class="w-10 h-10 mb-2 text-purple-700 md:w-12 md:h-12 dark:text-purple-500"
							fill="currentColor"
							viewBox="0 0 20 20"
							xmlns="http://www.w3.org/2000/svg">
							<path
								fill-rule="evenodd"
								d="M2 5a2 2 0 012-2h12a2 2 0 012 2v2a2 2 0 01-2 2H4a2 2 0 01-2-2V5zm14 1a1 1 0 11-2 0 1 1 0 012 0zM2 13a2 2 0 012-2h12a2 2 0 012 2v2a2 2 0 01-2 2H4a2 2 0 01-2-2v-2zm14 1a1 1 0 11-2 0 1 1 0 012 0z"
								clip-rule="evenodd"></path>
						</svg>
						<h3 class="mb-2 text-2xl font-bold dark:text-white">
							99.99% uptime
						</h3>
						<p class="font-light text-gray-500 dark:text-gray-400">
							For Pass2Peer, with zero maintenance downtime
						</p>
					</div>
					<div class="w-full flex flex-col items-center lg:items-start">
						<svg
							class="w-10 h-10 mb-2 text-purple-700 md:w-12 md:h-12 dark:text-purple-500"
							fill="currentColor"
							viewBox="0 0 20 20"
							xmlns="http://www.w3.org/2000/svg">
							<path
								d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z"></path>
						</svg>
						<h3 class="mb-2 text-2xl font-bold dark:text-white">
							10000+ Users
						</h3>
						<p class="font-light text-gray-500 dark:text-gray-400">
							Trusted by over 10 thousand users around the world
						</p>
					</div>
					<div class="w-full flex flex-col items-center lg:items-start">
						<svg
							class="w-10 h-10 mb-2 text-purple-700 md:w-12 md:h-12 dark:text-purple-500"
							fill="currentColor"
							viewBox="0 0 20 20"
							xmlns="http://www.w3.org/2000/svg">
							<path
								fill-rule="evenodd"
								d="M10 18a8 8 0 100-16 8 8 0 000 16zM4.332 8.027a6.012 6.012 0 011.912-2.706C6.512 5.73 6.974 6 7.5 6A1.5 1.5 0 019 7.5V8a2 2 0 004 0 2 2 0 011.523-1.943A5.977 5.977 0 0116 10c0 .34-.028.675-.083 1H15a2 2 0 00-2 2v2.197A5.973 5.973 0 0110 16v-2a2 2 0 00-2-2 2 2 0 01-2-2 2 2 0 00-1.668-1.973z"
								clip-rule="evenodd"></path>
						</svg>
						<h3 class="mb-2 text-2xl font-bold dark:text-white">
							100+ Institutions
						</h3>
						<p class="font-light text-gray-500 dark:text-gray-400">
							Have used Pass2Peer to share and help peers
						</p>
					</div>
					<div class="w-full flex flex-col items-center lg:items-start">
						<svg
							class="w-10 h-10 mb-2 text-purple-700 md:w-12 md:h-12 dark:text-purple-500"
							fill="currentColor"
							viewBox="0 0 20 20"
							xmlns="http://www.w3.org/2000/svg">
							<path
								d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"></path>
						</svg>
						<h3 class="mb-2 text-2xl font-bold dark:text-white">
							100+ Thousands
						</h3>
						<p class="font-light text-gray-500 dark:text-gray-400">
							Operations per day
						</p>
					</div>
				</div>
			</div>
		</section>

		<section class="bg-purple-700">
			<div class="max-w-screen-xl px-4 py-8 mx-auto lg:py-16 lg:px-6">
				<div class="max-w-screen-sm mx-auto text-center">
					<h2
						class="mb-4 text-3xl font-extrabold leading-tight tracking-tight text-white dark:text-white">
						Start using our services
					</h2>
					<p
						class="mb-6 font-light text-gray-300 dark:text-gray-400 md:text-lg">
						Try Pass2Peer Platform for sharing or searching any helpful material
					</p>
					<router-link
						to="/services"
						class="text-white bg-black hover:bg-gray-800 font-medium rounded-lg text-md px-6 py-3 mr-2 mb-2 focus:outline-none">
						Head over to services
					</router-link>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import { store } from '@/components/store'

export default {
	name: 'HomeView',
	data() {
		return {
			store
		}
	}
}
</script>

<style scoped>
.gradText {
	background-image: linear-gradient(
		to right,
		rgb(94, 80, 173),
		rgb(133, 35, 148),
		rgb(73, 5, 182)
	);
	background-clip: text;
	-webkit-text-fill-color: transparent;
	-moz-text-fill-color: transparent;
}
</style>
